import type { TrackService } from '@/domains/shared/services/track-service';
import { buildAiccEventDetail } from '@/presentation/utils/aicc-event-tracking';

export function trackAiccGuestToLogin(trackService: TrackService, pageUrl: string, taskId?: string) {
    trackService.trackAir({
        event_type: 'ss_telecom',
        source_type: 'telecom_aicc_home_guestToLogin',
        session_id: taskId || '',
        other_param: 'aicc',
        event_detail_str: buildAiccEventDetail(pageUrl, taskId ? { taskId } : {}),
    });
}
